// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nh-0";